export const prepareHtml = (html = '') => ({
  __html: html,
});
